

















import { defineComponent } from "@vue/composition-api";
import CloseDialog from "@c/atoms/app/CloseDialog.vue";
import CaldateChip from "@c/atoms/caldate/CaldateChip.vue";

export default defineComponent({
  name: "CaldatesPopup",

  components: {
    CloseDialog,
    CaldateChip
  },

  props: {
    caldates: {
      type: Array,
      default: []
    },
    title: String
  },

  setup() {
    return {};
  }
});
